"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Smoke = _interopRequireDefault(require("./Smoke"));
var _pixi = require("pixi.js");
var _gsap = _interopRequireDefault(require("gsap"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Background = exports["default"] = /*#__PURE__*/function (_Container) {
  function Background(scene, w, h, colorSet) {
    var _this;
    _classCallCheck(this, Background);
    _this = _callSuper(this, Background);
    _defineProperty(_this, "scene", void 0);
    _defineProperty(_this, "screenWidth", void 0);
    _defineProperty(_this, "screenHeight", void 0);
    _defineProperty(_this, "container", void 0);
    _defineProperty(_this, "graphics", void 0);
    _defineProperty(_this, "topGradient", void 0);
    _defineProperty(_this, "bottomGradient", void 0);
    _defineProperty(_this, "gradientContainer", void 0);
    _defineProperty(_this, "colorSet", void 0);
    _defineProperty(_this, "defaultColorSet", void 0);
    _defineProperty(_this, "smokeList", void 0);
    _defineProperty(_this, "blur", void 0);
    _defineProperty(_this, "warping", void 0);
    _defineProperty(_this, "annulus", void 0);
    _defineProperty(_this, "annulusSpeed", void 0);
    _defineProperty(_this, "sin", void 0);
    _defineProperty(_this, "isIdle", void 0);
    _defineProperty(_this, "tweenList", void 0);
    _defineProperty(_this, "data", void 0);
    _defineProperty(_this, "fireAnnulus", function () {
      _gsap["default"].killTweensOf(_this.annulus);
      _this.annulus.scale.set(0.1);
      _this.annulus.alpha = 1;
      _this.annulus.visible = true;
      _gsap["default"].to(_this.annulus.scale, {
        duration: 2.5,
        x: 3,
        y: 3,
        onComplete: function onComplete() {
          _this.annulus.visible = false;
        }
      });
      _gsap["default"].to(_this.annulus, {
        alpha: 0.4,
        duration: 2
      });
    });
    _this.colorSet = colorSet;
    _this.scene = scene;
    _this.screenWidth = w;
    _this.screenHeight = h;
    _this.container = new _pixi.Container();
    // WHY? something iphone only?
    _this.graphics = new _pixi.Graphics().beginFill(0xffffff, 0).drawRect(0, 0, _this.screenWidth, _this.screenHeight);
    _this.addChild(_this.graphics);
    _this.graphics.tint = 0;
    _this.addChild(_this.container);
    _this.topGradient = _pixi.Sprite.from("sky-gradient.png");
    _this.bottomGradient = _pixi.Sprite.from("sky-gradient.png");
    _this.gradientContainer = new _pixi.Container();
    _this.container.addChild(_this.gradientContainer);
    _this.gradientContainer.addChild(_this.topGradient);
    _this.topGradient.scale.x = w / _this.topGradient.width;
    _this.topGradient.scale.y = h / _this.topGradient.height;
    _this.topGradient.x = 0;
    _this.topGradient.y = 0;
    _this.gradientContainer.addChild(_this.bottomGradient);
    _this.bottomGradient.scale.x = _this.topGradient.scale.x;
    _this.bottomGradient.scale.y = -_this.topGradient.scale.y;
    _this.bottomGradient.x = 0;
    _this.bottomGradient.y = 0;
    _this.topGradient.anchor.set(0.5);
    _this.bottomGradient.anchor.set(0.5);
    _this.defaultColorSet = _this.colorSet;
    _this.smokeList = [];
    for (var index = 0; index < 4; index++) {
      var smoke = new _Smoke["default"](_this);
      smoke.build({
        num: 1,
        width: w,
        height: h,
        type: "top"
      });
      _this.container.addChild(smoke);
      _this.smokeList.push(smoke);
    }
    for (var _index = 0; _index < 4; _index++) {
      var _smoke = new _Smoke["default"](_this);
      _smoke.build({
        num: 2,
        width: w,
        height: h,
        type: "bottom"
      });
      _this.container.addChild(_smoke);
      _this.smokeList.push(_smoke);
    }
    _this.blur = _pixi.Sprite.from("blurStar.png");
    _this.container.addChild(_this.blur);
    _this.blur.scale.x = w / _this.blur.width;
    _this.blur.scale.y = h / _this.blur.height;
    _this.blur.anchor.set(0.5);
    _this.blur.scale.set(5);
    _this.blur.x = 0;
    _this.topGradient.tint = _this.colorSet.topGradientStandard;
    _this.bottomGradient.tint = _this.colorSet.bottomGradientStandard;
    _this.container.alpha = 0.4;
    _this.warping = false;
    _this.annulus = _pixi.Sprite.from("annulus_blur_20.png");
    _this.annulus.name = "ANNULUS";
    _this.addChild(_this.annulus);
    _this.annulus.anchor.set(0.5);
    _this.annulus.scale.set(0.1);
    _this.annulus.x = 0;
    _this.annulus.y = 0;
    _this.annulus.visible = false;
    _this.annulus["canBeVisible"] = true;
    _this.annulusSpeed = 2;
    _this.sin = 0;
    return _this;
  }
  _inherits(Background, _Container);
  return _createClass(Background, [{
    key: "update",
    value: function update() {
      for (var key in this.smokeList) {
        this.smokeList[key].update(key);
      }
    }
  }, {
    key: "setWarpEffect",
    value: function setWarpEffect(idle) {
      this.isIdle = idle;
      if (!idle) {
        this.warpStart();
      } else {
        this.warpEnd();
      }
    }
  }, {
    key: "resetColors",
    value: function resetColors() {
      this.colorSet = this.defaultColorSet;
    }
  }, {
    key: "warpStart",
    value: function warpStart() {
      for (var key in this.smokeList) {
        this.smokeList[key].warpping();
      }
      // this.container.alpha = 0.5;
      this.addColorTween(this.topGradient, this.topGradient.tint, this.colorSet.topGradientWarp, 3);
      this.addColorTween(this.bottomGradient, this.bottomGradient.tint, this.colorSet.bottomGradientWarp, 3);
      for (var _key in this.smokeList) {
        this.smokeList[_key].hide();
      }
      this.blur.tint = this.colorSet.centerZoneWarp;
      this.annulus.tint = this.colorSet.annulusWarp;
    }
  }, {
    key: "warpEnd",
    value: function warpEnd() {
      for (var key in this.smokeList) {
        this.smokeList[key].reset();
      }
      // this.container.alpha = 0.25;
      this.addColorTween(this.topGradient, this.topGradient.tint, this.colorSet.topGradientStandard, 2);
      this.addColorTween(this.bottomGradient, this.bottomGradient.tint, this.colorSet.bottomGradientStandard, 2);
      for (var _key2 in this.smokeList) {
        this.smokeList[_key2].show();
      }
      this.blur.tint = this.colorSet.centerZoneStandard;
    }
  }, {
    key: "killColorTween",
    value: function killColorTween(target) {
      for (var i = this.tweenList.length - 1; i >= 0; i--) {
        if (this.tweenList[i].target == target) {
          this.tweenList[i].tween.kill();
          this.tweenList.splice(i, 1);
        }
      }
    }
  }, {
    key: "addColorTween",
    value: function addColorTween(target, currentColor, targetColor) {
      var time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
      var delay = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      if (!this.tweenList) {
        this.tweenList = [];
      }
      var currentColorData = this.toRGB(currentColor);
      var targetColorData = this.toRGB(targetColor);
      var black = this.toRGB(0x000000);
      this.tweenList.push({
        tween: _gsap["default"].to(currentColorData, {
          duration: time,
          delay: delay,
          r: targetColorData.r,
          g: targetColorData.g,
          b: targetColorData.b,
          onUpdate: function (targ) {
            currentColorData.r = Math.floor(currentColorData.r);
            currentColorData.g = Math.floor(currentColorData.g);
            currentColorData.b = Math.floor(currentColorData.b);
            targ.tint = this.rgbToColor(currentColorData.r, currentColorData.g, currentColorData.b);
          }.bind(this),
          onUpdateParams: [target]
        }),
        target: target
      });
    }
  }, {
    key: "toRGB",
    value: function toRGB(rgb) {
      var r = rgb >> 16 & 0xff;
      var g = rgb >> 8 & 0xff;
      var b = rgb & 0xff;
      return {
        r: r,
        g: g,
        b: b
      };
    }
  }, {
    key: "rgbToColor",
    value: function rgbToColor(r, g, b) {
      return r << 16 | g << 8 | b;
    }
  }, {
    key: "build",
    value: function build(data) {
      this.data = data;
    }
  }, {
    key: "show",
    value: function show(delay) {}
  }, {
    key: "hide",
    value: function hide(delay) {}
  }, {
    key: "resize",
    value: function resize(w, h, yoffset) {
      this.x = w / 2;
      this.y = h / 2;
      var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
      if (iOS) {
        this.graphics.x = -w / 2;
        this.graphics.y = -h / 2;
        this.graphics.width = w;
        this.graphics.height = h;
      }
      this.topGradient.width = w;
      this.bottomGradient.width = w;
      this.topGradient.height = h;
      this.bottomGradient.height = h;
      this.annulus.x = 0;
      this.annulus.y = yoffset * -1;
      this.blur.y = yoffset * -1;
    }
  }]);
}(_pixi.Container);
//# sourceMappingURL=Background.js.map